export function getIsPromotional(combinedMapPrice, planDuration) {
  const { price, mapRuleSatisfied, mapPriceDisplay } = combinedMapPrice || {};

  if (!combinedMapPrice) {
    return !planDuration;
  } else if (
    isNaN(price) ||
    price === 0 ||
    (Boolean(mapRuleSatisfied) && !mapPriceDisplay) ||
    !planDuration
  ) {
    return true;
  }

  return false;
}
